var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#2B4896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.182 228.687L-28.4746 513.374H21.7754V529.28L262.807 258.843L228.182 228.687Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-12.7673 550.859L235.407 274.472L216.483 276.328V275.453L-24.3298 540.359L-12.7673 550.859Z",
    fill: "#E32D3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M494.781 -18.3232L238.125 266.364H288.375V282.271L530.406 13.833L494.781 -18.3232V-18.3232Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M505.25 -14.5312L255.75 260H276V260.875L516.813 -4.03125L505.25 -14.5312V-14.5312Z",
    fill: "#E32D3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.31 290.096L-29.6775 -3.85924L20.5384 -2.00689L21.1247 -17.9023L253.096 259.275L216.31 290.096V290.096Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.912 286.692L-12.2985 3.15046L7.93776 3.89693L7.97001 3.02252L238.854 276.626L226.912 286.692V286.692Z",
    fill: "#E32D3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M296 16H216V496H296V16Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M294.501 238.085L551.157 522.772H500.907V538.679L258.876 270.241L294.501 238.085V238.085Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M284.031 241.877L533.531 516.408H513.281V517.283L272.469 252.377L284.031 241.877V241.877Z",
    fill: "#E32D3C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M496 296V216H16.0001V296H496Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M280 16H232V496H280V16Z",
    fill: "#E32D3C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M496 280V232H16.0001V280H496Z",
    fill: "#E32D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.d38617828ec001a3e911caee97e26b88.svg";
export { ForwardRef as ReactComponent };